// Skerpa Copilot types — chat + structured actions

export type SkerpaAction =
  | { action: 'add_entity'; label: string; entityType: string; section?: string; description?: string }
  | { action: 'update_entity'; name: string; updates: Record<string, string>; entityType: string }
  | { action: 'batch_update'; entityType: string; items: Array<{ name: string; updates: Record<string, string> }>; description?: string }
  | { action: 'delete_entity'; name: string; entityType: string }
  | { action: 'link_entities'; source: { name: string; entityType: string }; target: { name: string; entityType: string }; relation: string }
  | { action: 'focus_entity'; name: string; entityType: string }
  | { action: 'navigate'; target: string; label?: string }
  | { action: 'interview'; questions: string[] }

export interface HermesChatMessage {
  id: string
  role: 'user' | 'assistant'
  content: string
  actions?: SkerpaAction[]
  createdAt: string
}

// ── Skerpa Agent Mode ──
// Controls which models the agent can use
export type SkerpaMode = 'standard' | 'plus' | 'premium'

export const SKERPA_MODE_LABELS: Record<SkerpaMode, string> = {
  standard: 'Standard',
  plus: 'Plus',
  premium: 'Premium',
}

export const SKERPA_MODE_DESCRIPTIONS: Record<SkerpaMode, string> = {
  standard: 'Haiku · Sonnet · Opus',
  plus: 'Sonnet · Opus',
  premium: 'Opus',
}

export interface HermesChatStreamEvent {
  type: 'text' | 'done' | 'error' | 'meta'
  data: {
    content?: string
    messageId?: string
    message?: string
    provider?: string
    model?: string
  }
}

// ── Proactive Guide types ──

export type GuideUrgency = 'critical' | 'high' | 'medium' | 'low'

export type GuideDomain = 'market' | 'business' | 'solution' | 'general'

export interface GuideCard {
  id: string
  title: string
  description: string
  urgency: GuideUrgency
  domain: GuideDomain
  icon: string
  prompt: string
  viewTarget?: string
}
